export default {
  // TODO: replace with @swa-ui/form disclaimer onece it exists
  MissingInformationForm__ALL_REQUIRED: "*All fields required unless otherwise denoted.",
  MissingInformationForm__AND: "and",
  MissingInformationForm__EMAIL: "email",
  MissingInformationForm__HEADING: "Update profile information",
  MissingInformationForm__PHONE: "phone",
  MissingInformationForm__RULES_AND_REGULATIONS: "Rules and Regulations",
  MissingInformationForm__SECURITY_CHALLENGE: "security questions",
  MissingInformationForm__SUBHEADING: (options) =>
    `Welcome to Rapid Rewards^^®^^. We need a little more information in order to complete your account. Create your ${options.formattedMissingInformation}.`,
  MissingInformationForm__TERMS_AGREE: "I acknowledge and accept the",
  MissingInformationForm__TERMS_AGREE_REQUIRED: "You must accept the Rules and Regulations.",
  MissingInformationForm__USERNAME: "username",
  MissingInformationForm__USERNAME_AVAILABLE: "Yes, it is available!",
};
